import styled from "styled-components";
import { Button, ButtonWithIcon, DataTableActionButton, DataTableCell, mobile, tablet, desktop } from "src/components";

export const ButtonWithIconStyled = styled(ButtonWithIcon)`
    max-width: 15.125rem;
    margin-bottom: .5em;
    margin-right: .5em;
    ${mobile`
        margin-top: 1em;
        margin-bottom: 1em;
    `};
`;

export const DeleteButtons = styled(Button)`
    display: flex;
    width: 110px;
    height: 42px;
    justify-content: center;
    font-family: Manrope, Helvetica, sans-serif;
    background: #FFF5F5 0% 0% no-repeat padding-box;
    box-shadow: none;
    border: 1px solid #FF3B3B;
    border-radius: 8px !important;
    opacity: 1;
    color: #FF3B3B;
    cursor: pointer;
`;

export const ButtonLabel = styled(DataTableActionButton)`
    width: 101px;
    height: 32px;
    background: #F3F5FB 0% 0% no-repeat padding-box;
    box-shadow: none;
    border: 1px solid #C9D2E7;
    border-radius: 8px;
    opacity: 1;
    cursor: pointer;
    color: #171A22;
    font-family: 'Manrope', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 19px;
`;

export const Td = styled(DataTableCell)`
    padding: 0;
    text-align: ${p => p.align || "left"};
    padding-left: ${p => p.paddingLeft || "1rem !important"};
    vertical-align: top;
`;

export const TdCenter = styled(DataTableCell)`
    text-align: center;
    vertical-align: middle;
    
    & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
`;

export const TdContent = styled.div`
    width: 100%;
    min-height: 60px;
    min-width: 200px;
    max-width: 800px;
    word-break: break-word;
    white-space: normal;
    overflow-wrap: break-word;
    font-family: 'Manrope', sans-serif;

    ${mobile`
        min-width: 150px;
        max-width: 300px;
    `}
`;


export const UpperControls = styled.div`
    display: flex;
    width: 100%;
    box-sizing: border-box;
    max-width: 98.625rem;
    background: #FFF;
    min-height: 5.625rem;
    justify-content: normal;
    align-items: baseline;
    border-radius: 16px 16px 0 0;
    border: 1px solid #D8DEEC;
    border-bottom: none;
    box-shadow: 0 18px 36px rgba(29, 42, 89, 0.08);

    ${tablet`
        padding: 1rem 0;
        flex-direction: column;
    `};

    ${mobile`
        padding: 1rem 0;
        flex-direction: column;
    `};

    ${desktop`
        padding: 1.5rem 0;
        flex-direction: row;
    `};
`;

export const SearchInput = styled.input`
    position: relative;
    background-image: url('data:image/svg+xml;utf8,\
        <svg fill="none" height="18" viewBox="0 0 16 16" width="18" xmlns="http://www.w3.org/2000/svg">\
            <circle cx="6" cy="6" r="5" stroke="%238291B2" stroke-width="1.5"/>\
            <line x1="10" y1="10" x2="13.5" y2="13.5" stroke="%238291B2" stroke-width="1.5" stroke-linecap="round"/>
        </svg>');
    background-repeat: no-repeat;
    font-family: 'Manrope', sans-serif;
    font-size: 14px;
    font-style: normal;
    text-indent: 40px;
    background-position: 16px center;
    box-shadow: none;
    border: 1px solid #D8DEEC;
    border-radius: 8px;
    height: 42px;
    box-sizing: border-box;
    text-align: left;
    width: 49.375rem;
    max-width: 545px;
    margin: 0 20px;

    ::placeholder {
        font-size: 14px;
        text-align: left;
        color: #8A95AB;
    }

    ${mobile`
        max-width: 190px;
        margin: 1rem 1rem;
    `}

    @media (min-width: 481px) and (max-width: 767px){
        max-width: 200px;
        margin: 0 1rem;
    }

    @media (min-width: 768px) and (max-width: 1024px){
        max-width: 200px;
        margin: 0 1rem;
    }

    @media (min-width: 1025px) and (max-width: 1440px){
     max-width: 300px;
        margin: 0 1rem;
    }

    @media (min-width: 1441px){
        max-width: 500px;
        margin: 0 1rem;
    }
`;

export const ButtonsFlexWrap = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    ${mobile`
        flex-direction: row;
        align-items: flex-start;
        gap: 10px;
    `}
`;

export const AddButtonWrapper = styled.div`
    margin-left: auto;

    ${mobile`
        margin-left: auto;
        margin-top: 0.5rem;
    `}
`;
